import { useCurrentShopSuspense } from "@/api/shops/use-current-shop-suspense";
import { red } from "@/pages/(app)/home/components/colors";
import { Truck } from "lucide-react";
import { useCallback, useEffect } from "react";
import { useReturnRequestsFilters } from "../../../providers/use-return-requests-filters";
import useCountFilteredReturnRequests from "@babackapp/private-api-client/client/use-count-filtered-return-requests";
import useTranslation from "@babackapp/translations/use-translation";
import QuickFilterItem from "./quick-filter-item";

export default function CarrierErrorQuickFilter() {
  const { data: shop } = useCurrentShopSuspense();
  const t = useTranslation();
  const { filters, clearAll, quickFilter, setQuickFilter } =
    useReturnRequestsFilters();

  const status = filters.get("status");
  const isCarrierIssues = quickFilter === "carrierIssues";
  const active = !status && isCarrierIssues;

  const onClick = useCallback(() => {
    clearAll();
    setQuickFilter("carrierError");
  }, [filters]);

  const { data: results, refetch } = useCountFilteredReturnRequests({
    shopId: shop.id,
    filters,
    quickFilter: "carrierError",
  });

  useEffect(() => {
    refetch();
  }, [refetch]);

  if (!results?.totalCount) return <></>;

  return (
    <QuickFilterItem
      count={results?.totalCount}
      active={active}
      title={t("returnRequestsQuickFilters.carrierError.title")}
      description={t("returnRequestsQuickFilters.carrierError.description")}
      icon={<Truck className="size-3" color={red} />}
      onClick={onClick}
    />
  );
}
